/**
 * The Hit again step's collapsed summary, in the operator's words.
 * (20/10/2026 — user: "the up to must be an option … and also a sms cap",
 * then "by default … always hit … and maybe an option to set a limit": no
 * limit and no cap are the defaults and say nothing; "at most N in a row"
 * and "cap M SMS" show only when they were set.)
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenHitAmountMode } from '@trafficpulse/shared';

import type { ContainerDraft } from '../../../../drop-generator.types';

const n = (v: number) => v.toLocaleString('en-US');

export function hitAmountWords(mode: DropGenHitAmountMode, pct: number, fixed: number | null): string {
  switch (mode) {
    case 'same':
      return 'the same amount again';
    case 'drop_pct':
      return `${pct >= 0 ? '+' : '−'}${Math.abs(pct)} % of the drop`;
    case 'base_pct':
      return `${pct >= 0 ? '+' : '−'}${Math.abs(pct)} % of the base`;
    case 'fixed':
      return fixed === null ? 'a fixed amount' : `fixed ${n(fixed)}`;
  }
}

/** Only what was set: "at most 3 in a row" and "cap 2,000 SMS"; no limit and no cap (the defaults) say nothing. */
export function hitLimitWords(maxTimes: number | null, cap: number | null): string {
  const times = maxTimes === null ? null : maxTimes === 1 ? 'once' : `at most ${maxTimes} in a row`;
  return [times, cap !== null ? `cap ${n(cap)} SMS` : null].filter(Boolean).join(' · ');
}

export function hitAgainSummary(draft: ContainerDraft): string {
  const h = draft.hitAgain;
  if (!h.enabled) return 'off — no drop is sent again';
  if (h.rule.advanced) return 'nested rule (set through the API)';
  if (h.rule.rows.length === 0) return 'no rule — no drop is sent again';
  const when = h.when === 'CONTAINER' ? " · in the container's hours" : '';
  // duplicates on is the default and says nothing
  const duplicate = h.duplicate ? '' : ' · Duplicate off';
  const limits = hitLimitWords(h.maxTimes, h.cap);
  return `${h.rule.rows.length} condition${h.rule.rows.length === 1 ? '' : 's'} · ${hitAmountWords(h.mode, h.pct, h.fixed)}${limits ? ` · ${limits}` : ''}${when}${duplicate}`;
}
